// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentWishListsStyles } from "@insite/content-library/Widgets/Common/RecentWishLists";
import getColor from "@insite/mobius/utilities/getColor";
import Cart from "@rugby/XDL/Icons/Cart";
import { ellipsis } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

recentWishListsStyles.wishListCard = {
    detailLinkGridItem: {
        css: css`
            a[data-test-selector="wishListCardName"] {
                span {
                    color: ${getColor("secondary")};
                    font-weight: bold;
                    font-size: 15px;
                    line-height: 22px;
                    ${ellipsis(2)}
                }
            }
        `,
    },
    actionAddToCartButton: {
        variant: "primary",
        color: "primary",
        typographyProps: {
            size: 15,
            css: css`
                font-weight: bold;
                letter-spacing: 0;
                line-height: 18px;
            `,
        },
        icon: {
            src: Cart,
            position: "left",
        },
    },
};
